<template>
  <section class="errors-404">
    <context-state state="notfound">
      <template v-slot:notfound>
        <typography-heading>
          404

          <template v-slot:subtitle>
            A página que você tentou acessar não existe no Credere :(
          </template>
        </typography-heading>
      </template>
    </context-state>
  </section>
</template>

<script>
  import ContextState from '@cordel/components/Context/State.vue';
  import TypographyHeading from '@cordel/components/Typography/Heading.vue';

  export default {
    name: 'Errors404',
    components: {
      ContextState,
      TypographyHeading,
    },
  };
</script>

<style lang="scss" scoped>
  .errors-404 {
  }
</style>
